import type * as THREE from "three";
import { Circle } from "@designboticteam/workspace-3d";

class ProjectArea extends Circle {
	constructor({
		maxRadius,
		circleColor,
		centerMarkerColor,
		radiusLineColor,
	}: {
		maxRadius: number;
		circleColor: THREE.ColorRepresentation;
		centerMarkerColor: THREE.ColorRepresentation;
		radiusLineColor: THREE.ColorRepresentation;
	}) {
		super({
			circleColor,
			centerMarkerColor,
			radiusLineColor,
			maxRadius,
		});
	}
}

export { ProjectArea };
